import { render, staticRenderFns } from "./SupplyToLineQrView.vue?vue&type=template&id=2b4778a5&scoped=true&"
import script from "./SupplyToLineQrView.vue?vue&type=script&lang=js&"
export * from "./SupplyToLineQrView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4778a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
